import React from 'react';
import { Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-10 px-6" data-id="element-167">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-petroleo rounded-3xl p-8 md:p-10 text-center border border-tealBrand/30 relative overflow-hidden" data-id="element-168">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-tealBrand to-transparent" data-id="element-169"></div>

        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-nocheLight border-2 border-tealBrand/50 mb-4" data-id="element-170">
          <Shield className="w-8 h-8 text-tealBrand" data-id="element-171" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-172">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-173">
          Usás los tomos en el aula. Si en 7 días no es exactamente lo que
          esperabas: devolución del 100% sin formularios, sin drama.
        </p>

        <div className="inline-block bg-tealBrand/10 border border-tealBrand/30 text-tealBrand font-semibold px-6 py-2 rounded-full text-sm" data-id="element-174">
          Tasa de devoluciones: menos del 1%
        </div>
      </motion.div>
    </section>;
}